import styled from '@emotion/styled'
import { Close } from 'emotion-icons/material'

export const ModalTrigger = styled.span`
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
  line-height: 16px;

  &:has(button) {
    // Buttons will handle their own styles
    text-decoration: none;
  }

  .leshen-package-card & {
    display: inline-block;
    margin-bottom: 8px;
    color: black;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  border: 0;
  background-color: ${({ theme }) => theme.colors.light.darkest.hex};
  border-radius: 50px;
  height: 25px;
  width: 25px;
  right: 20px;
  top: 20px;
  cursor: pointer;
  z-index: 1;
`

export const CloseIcon = styled(Close)`
  color: white;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    position: absolute;
    left: 2px;
    top: 2px;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
  }
`
